import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["onUploadSuccess", "onUploadFailure", "removeFile", "file", "clearErrors", "error", "required", "acceptedMediaType"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { toStaticUrl } from '@infl-ts/util-to-static-url';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, FormHelperText, Tab } from '@mui/material';
import { absurd, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as Str from 'fp-ts/string';
import { useCallback, useState } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FILESTACK_API_KEY, NODE_ENV, PRIVATE_S3_BUCKET } from '../../env'; // AI-GEN - Cursor and GPT4

import { FileDropPane, UploadedFileInfo, UploadFromCapture, UploadFromUrl } from '../file-uploader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var getStorePath = function getStorePath(acceptedMediaType) {
  switch (acceptedMediaType) {
    case 'image':
      return 'images';

    case 'video':
      return 'raw';

    case 'file':
      return 'docs';

    default:
      return absurd(acceptedMediaType);
  }
};

var storePrefix = function storePrefix(acceptedType) {
  return acceptedType === 'image' ? 'temporary/' : '';
};

var MediaUploadFormField = function MediaUploadFormField(_ref) {
  var onUploadSuccess = _ref.onUploadSuccess,
      onUploadFailure = _ref.onUploadFailure,
      removeFile = _ref.removeFile,
      file = _ref.file,
      clearErrors = _ref.clearErrors,
      error = _ref.error,
      required = _ref.required,
      acceptedMediaType = _ref.acceptedMediaType,
      controllerProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState('Browse'),
      currentTab = _useState[0],
      setCurrentTab = _useState[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var storeParams = {
    location: 's3',
    container: PRIVATE_S3_BUCKET,
    // AI-GEN - Cursor and GPT4
    //TODO: Use a path of this format: files/{hub.id}/{profile.id}/{getStorePath(acceptedMediaType)}
    path: "files/".concat(storePrefix(acceptedMediaType)).concat(getStorePath(acceptedMediaType), "/"),
    access: 'private',
    region: 'us-east-1'
  };
  var handleUploadSuccess = useCallback(function (file) {
    return pipe(file, O.fromPredicate(function (file) {
      return !!file.key;
    }), O.map(function (url) {
      return toStaticUrl(url, NODE_ENV);
    }), O.map(onUploadSuccess), O.getOrElseW(function () {
      return onUploadFailure(t('Failed to upload image, try again.'));
    }));
  }, [onUploadSuccess]);
  var containerId = "filestack-picker-container-".concat(controllerProps.name);
  return /*#__PURE__*/_jsx(Box, {
    id: "".concat(containerId, "-root"),
    "data-element": "Box",
    "data-component": "MediaUploadFormField",
    "data-source-file": "media-upload-form-field.tsx",
    children: /*#__PURE__*/_jsx(Controller, _objectSpread(_objectSpread({}, controllerProps), {}, {
      rules: _objectSpread(_objectSpread({}, controllerProps.rules), {}, {
        required: required
      }),
      render: function render() {
        return /*#__PURE__*/_jsxs(TabContext, {
          value: currentTab,
          children: [/*#__PURE__*/_jsxs(TabList, {
            onChange: function onChange(_, value) {
              clearErrors();
              setCurrentTab(value);
            },
            sx: {
              mb: 1
            },
            children: [/*#__PURE__*/_jsx(Tab, {
              label: t('Browse'),
              value: "Browse"
            }), acceptedMediaType !== 'file' && /*#__PURE__*/_jsx(Tab, {
              label: t('Capture'),
              value: "Capture"
            }), /*#__PURE__*/_jsx(Tab, {
              label: t('Link'),
              value: "Link"
            })]
          }), file ? /*#__PURE__*/_jsx(UploadedFileInfo, {
            uploadedFile: file,
            onRemove: removeFile,
            containerId: containerId
          }) : /*#__PURE__*/_jsxs(Box, {
            sx: {
              display: file ? 'none' : 'block'
            },
            children: [/*#__PURE__*/_jsxs(TabPanel, {
              value: "Browse",
              sx: {
                p: function p(t) {
                  return t.spacing(1, 0);
                }
              },
              children: [/*#__PURE__*/_jsx(FileDropPane, {
                questionId: controllerProps.name,
                apiKey: FILESTACK_API_KEY,
                onSuccess: handleUploadSuccess,
                onError: onUploadFailure,
                error: !!error,
                acceptedMediaType: acceptedMediaType,
                storeParams: storeParams
              }), error ? /*#__PURE__*/_jsx(FormHelperText, {
                error: !!error,
                children: error.message && !Str.isEmpty(error.message) ? error.message : t('This field is required.')
              }) : null]
            }), acceptedMediaType !== 'file' && /*#__PURE__*/_jsxs(TabPanel, {
              value: "Capture",
              sx: {
                p: function p(t) {
                  return t.spacing(1, 0);
                },
                maxHeight: '550px'
              },
              children: [/*#__PURE__*/_jsx(UploadFromCapture, {
                containerId: containerId,
                onSuccess: handleUploadSuccess,
                onError: onUploadFailure,
                error: !!error,
                sourceType: acceptedMediaType === 'image' ? 'webcam' : 'video',
                storeParams: storeParams
              }), error ? /*#__PURE__*/_jsx(FormHelperText, {
                error: !!error,
                sx: {
                  position: 'absolute',
                  bottom: '50px'
                },
                children: error.message && !Str.isEmpty(error.message) ? error.message : t('This field is required.')
              }) : null]
            }), /*#__PURE__*/_jsxs(TabPanel, {
              value: "Link",
              sx: {
                p: function p(t) {
                  return t.spacing(1, 0);
                }
              },
              children: [/*#__PURE__*/_jsx(UploadFromUrl, {
                onSuccess: handleUploadSuccess,
                onError: onUploadFailure,
                storeParams: storeParams,
                acceptedMediaType: acceptedMediaType,
                error: !!error
              }), error ? /*#__PURE__*/_jsx(FormHelperText, {
                error: !!error,
                children: error.message && !Str.isEmpty(error.message) ? error.message : t('This field is required.')
              }) : null]
            })]
          })]
        });
      },
      "data-element": "Controller",
      "data-component": "MediaUploadFormField",
      "data-source-file": "media-upload-form-field.tsx"
    }))
  });
};

export default MediaUploadFormField;